module.exports = __webpack_public_path__ + "img/stripe-logo.552f9814.svg";